<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="acknowledgement">
<h1>Acknowledgement</h1>
<p>I would like to offer my sincere thanks to Mike Pengelly, Ashley Bussell, Brian Porter, Pat Mcaree, Richard Butters, Clive Pearn, Alan Williams and Amy Reeves for helping me recall and revive some of my memories of past events, which has helped me compile this book with accompanying photographs. I would also like to thank the Board of Commissioners of the ‘East and West Looe Harbour and Bridge’ Charity for their permission to access the Looe Harbour archives.</p>
<p><strong><br/>
</strong></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch004.vue?58869508